import { createContext } from 'react';

import type { XYChartAxisInternal } from '../../types/xy-chart-internals.js';

export const XYChartAxesConfigContext = createContext<
  XYChartAxisInternal[] | undefined
>(undefined);

XYChartAxesConfigContext['displayName'] = 'XYChartAxesConfigContext';
